import { Message } from "../models";

export const getAttachment = (message: Message) => {
  if (message.isFromUser) {
    return message.attachments?.[0];
  }

  return message.attachment;
};
